/**
 * author: Ananthapadmanabhan
 */
import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { OverlayTrigger } from "react-bootstrap";
import "./StandardsAdminMain.scss";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import { BiChevronDown, BiPlus, BiPencil, BiGitMerge } from "react-icons/bi";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Utils from "../../../../core/utilities/Utils";
import AddTopic from "../AddTopic/AddTopic";
import StandardService from "../../../../core/service/StandardService";
import StandardsCreate from "../StandardsCreate/StandardsCreate";
import Topics from "../Topics/Topics";
import CreateMetric from "../CreateMetric/CreateMetric";
import Metric from "../Metric/Metric";
import { RegulationContext } from "../../../../App";
import DataPoints from "../DataPoints/DataPoints";
import CreateDataPoint from "../CreateDataPoint/CreateDataPoint";
import { AiOutlineCalculator } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { SUBSCRIBER_ADMIN_TXT } from "../../../../core/constants/api";
import { LS_AUTHORITY_KEY, USER_ROLE } from "../../../../core/constants/common";

const StandardsAdminMain = ({ t, listObj, handleChildToggle, parent, sType, setChild, forSuperAdmin }) => {
  let lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [showTopic, setShowTopic] = useState(false);
  const [editTopicId, setEditTopicId] = useState("");
  const [shown, setShown] = useState({});
  const [openStandardSave, setOpenStandardSave] = useState(false);
  const [editStandardItem, setEditStandardItem] = useState({});
  const [stdId, setStdId] = useState("");
  const [type, setType] = useState(sType);
  const [data, setData] = useState([]);
  const [list, setList] = useState(listObj);
  const [showMetric, setShowMetric] = useState(false);
  const [topicId, setTopicId] = useState("");
  const [editMetricId, setEditMetricId] = useState("");
  const { setGlbRegulations } = useContext(RegulationContext);
  const [showDataPoints, setShowDataPoints] = useState(false);
  const [metricId, setMetricId] = useState("");
  const [categorydata, setCategoryData] = useState([]);
  const [dsList, setDsList] = useState([]);
  const [shownInside, setShownInside] = useState({});
  const [currentDs, setCurrentDs] = useState([]);
  const [currentcategory, setCurrentCategory] = useState(null);
  const [editDataPointId, setEditDataPointId] = useState("");
  const [editdata, setEditData] = useState(null);
  const [equation, setEquation] = useState(null);
  const navigate = useNavigate();
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(true);
  useEffect(() => {
    var lsDat = JSON.parse(localStorage.getItem('authority'));
    if (lsDat.roles.includes("SUPER_ADMIN")) {
      setIsCompanyAdmin(false);
    }else{
      setIsCompanyAdmin(true);
    }
    listObj['socialcount'] = 0
    listObj['environmentcount'] = 0
    listObj['governencecount'] = 0
    setList(listObj);
  }, [listObj, listObj?.status]);


  const getCategory = async (e) => {
    StandardService.getCategory(lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        setCategoryData([...response.data]);
        // filterCategoryData()
      })
      .catch((error) => { });
  };

  const handleExpand = (id, itemType) => {
    // console.log('itemTypeitemType',itemType,shown)
    getCategory();
    setShowTopic(false);
    setShowMetric(false);
    const newVal = !shown[id];
    var obj = function (shown) {
      Object.keys(shown).forEach(function (key) {
        shown[key] = false;
      });
      return shown;
    };
    setShown({
      ...obj,
      [id]: newVal,
    });
    if (itemType === "STANDARD") {
      getTopics(id);
    }
    else if (itemType === "TOPIC") {
      setTopicId(id);
      getMetric(stdId, id);
    }
    else if (itemType === "METRIC") {
      setMetricId(id);
      getDataPoints(id);
    }
    // else {
    // }
  };
  const getTopics = (stdid) => {
    StandardService.getTopics(stdid, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        setList(response?.data);
        const topics = response?.data?.topics;
        if (Array.isArray(topics)) {
          setData([...topics]);
        } else {
          setData([]);
        }

      })
      .catch((error) => { });
  };

  const getDataPoints = (mId) => {
    StandardService.getDataPoints(mId, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        setList(response?.data.body);
        const dataPoints = response?.data?.body?.dataPoints;
        if (Array.isArray(dataPoints)) {
          setData([...dataPoints]);
        } else {
          setData([]);
        }

      })
      .catch((error) => {
      });
  };

  const handleDiscard = (isDiscard) => {
    setShowTopic(!isDiscard);
    setShowMetric(!isDiscard);
    setShowDataPoints(!isDiscard);
  };
  const handleAfterSave = (id) => {
    getTopics(id);
    // setShowTopic(false);
    // setShowMetric(false);
  };
  const handlePublish = (list) => {
    let status = "PUBLISHED";
    StandardService.updateStandardStatus(list.id, status, list, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        if (response.status === 200) {
          setGlbRegulations(response?.data);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          var data = {
            standardId: list.id,
            childStatus: "Close",
            type: "STANDARD",
            parent: 0,
          };
          handleChildToggle(data);
        }
      })
      .catch((error) => { });
  };

  const editStandard = (list) => {
    setOpenStandardSave(true);
    setEditStandardItem(list);
  };
  const handleEditCallback = (obj) => {
    setOpenStandardSave(obj.val);
    var data = {
      standardId: list.id,
      childStatus: "Close",
      type: obj.type,
      parent: 0,
    };
    handleChildToggle(data);
  };

  const handleDeleteCallback = (stdid, id, type) => {
    StandardService.deleteTopic(stdid, id, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getTopics(stdid);
        }
      })
      .catch((error) => { });
  };


  const handleDeleteDataPointCallback = (id) => {
    StandardService.deleteDataPoint(id, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getDataPoints(metricId);
        }
      })
      .catch((error) => { });
  };

  const handleEditTopicCallback = (obj) => {
    setShowTopic(true);
    setStdId(obj.stdId);
    setEditTopicId(obj.id);
  };
  const handleTopicChild = (obj) => {
    setType(obj.type);
    setStdId(obj.stdId);
    getMetric(obj.stdId, obj.id);
    handleExpand(obj.id, obj.type);
    setChild(true, list.id)
  };
  const getMetric = (stdid, topicid) => {
    StandardService.getMetrics(stdid, topicid, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        setData([...response.data.metrics]);
        setList(response.data);
      })
      .catch((error) => { });
  };
  const handleCloseChild = (id) => {
    setShowMetric(false);
    if (type === "TOPIC") {
      setShown({ [stdId]: true });
      setType("STANDARD");
      getTopics(stdId);
    } else if (type === "METRIC") {
      setType("TOPIC");
      getMetric(stdId, id);
      setShown({ [id]: true });
    }
  };
  const handleDeleteMetricCallback = (stdId, metricId, tpcId) => {
    StandardService.deleteMetric(metricId, lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getMetric(stdId, tpcId);
        }
      })
      .catch((error) => { });
  };
  const handleEditMetricCallback = (obj) => {
    setShowMetric(true);
    setStdId(obj.stdId);
    setTopicId(obj.topicId);
    setEditMetricId(obj.id);
  };

  const handleEditDataPointCallback = (obj) => {
    setShowDataPoints(true);
    // setStdId(obj.stdId);
    setMetricId(obj.metricId);
    setEditDataPointId(obj.id);
    setEditData(obj.data)
  };

  const handleAfterMetricSave = () => {
    getMetric(stdId, topicId);

  }
  const handleAfterDataPointSave = () => {
    getDataPoints(metricId);

  }
  const handleMetricDiscard = (isDiscard) => {
    setShowTopic(!isDiscard);
    setShowMetric(!isDiscard);
    setShowDataPoints(!isDiscard)
  }
  const handleMetricChild = (obj) => {
    setEquation(obj.equation);
    setType(obj.type);
    setStdId(obj.stdId);
    getDataPoints(obj.id);
    handleExpand(obj.id, obj.type);
  };

  const handleExpandDs = (e, categoryType) => {
    // setCurrentCategory(categoryType);
    // setDsList([]);
    // setCurrentDs([]);
    // currentDs.length = 0;
    // setCurrentDs(currentDs);
    // //setSelDataSource(id);

    const newVal = !shownInside[categoryType];
    if (newVal) {
      let obj = { categoryType: categoryType };
      setCurrentDs([...currentDs, obj]);
    }
    setShownInside({
      [categoryType]: !shownInside[categoryType],
    });
    // console.log('shownInsideshownInside',shownInside)
    //  setIsExpanded(true);
  };

  const handleCount = (categoryObj) => {
    let listdata = list;
    listdata['socialcount'] = categoryObj[0].arrayLength
    listdata['environmentcount'] = categoryObj[1].arrayLength
    listdata['governencecount'] = categoryObj[2].arrayLength
    setList(listdata);
    // console.log('datadata',categoryObj,list)
  }

  const countCalculate = (category) => {
    // console.log('categorycategory', category, list)
    switch (category) {
      case 'SOCIAL': return list.socialcount
      case 'ENVIRONMENTAL': return list.environmentcount
      case 'GOVERNANCE': return list.governencecount
      default:
        break;
    }
  }

  const gotoTopic = (name, id, freq) => {
    localStorage.setItem('standardName', name);
    let url = '';
     if(isCompanyAdmin) {
      url = '/company_admin/topiclist/' + id;
    } else if (forSuperAdmin) {
      url = '/admin/std_template_config/' + id + '?name=' + name + '&freq=' + freq;
    } else {
      url = '/admin/topiclist/' + id;
    }
    navigate(url);
  }
  return (
    <>
      <div
        className={`card StandardsAdminMain_listCard 1  ${list?.status === "DRAFT" ? "bg-light-blue" : ""
          } `}
        id={list?.id}
        key={list?.id}
      >
        <div className="card-body p-0">
          <div className="SML_Add_Card_row01">
            <div className="row m-0">
              <div className="col-lg-8 p-1">
                <div className="row m-0 SML_Add_Card_head">
                  <div className="col-lg-4 p-0">
                    <ul>
                      <li>
                        <h6 className="mb-0 me-2 cursor" onClick={() => gotoTopic(list?.name, list?.id, list?.frequency)} >{list?.name}</h6>
                      </li>
                      {type !== "STANDARD" &&
                        <li><span><strong>{list.childrenCount}</strong> <BiGitMerge /></span></li>
                      }
                      {/* <li>
                        <div className="AddEquation_box 5">
                          <span className="cursor">
                            <AiOutlineCalculator /> Add Equation
                          </span>
                        </div>
                      </li> */}
                    </ul>
                  </div>
                  {type === "STANDARD" && (
                    <>
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            {t("ReportingFrequency.label")}
                            <h6 className="mb-0 ms-2">
                              {t(list?.frequency + ".label")}
                            </h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            {t("LastModified.label")}{" "}
                            <h6 className="mb-0 ms-2">
                              {moment(list?.lastModifiedDate).format(
                                "MMM DD, YYYY"
                              )}
                            </h6>
                          </li>
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {type !== "STANDARD" && (
                <div className="col-lg-4 p-1 text-end">
                  <button
                    className="btn btn-secondary"
                    onClick={() => handleCloseChild(list?.id)}
                  >
                    {t("Back.label")}
                  </button>
                </div>
              )}
              {type === "STANDARD" && (
                <div className="col-lg-4 p-1 text-end">
                  <div className="row m-0 ">
                    {lsData?.roles?.includes("SUPER_ADMIN") && (
                      <div className="col-lg-4 p-0 text-end">
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("EditCompliance.label")
                          )}
                        >
                          <button
                            className="btn btn-blank_outline"
                            onClick={() => editStandard(list)}
                          >
                            <BiPencil />
                          </button>
                        </OverlayTrigger>
                      </div>
                    )}
                    {list?.status === "DRAFT" && (
                      <div className="col-lg-8 p-0 text-end">
                        <button
                          className="btn btn-primary "
                          onClick={(e) => handlePublish(list)}
                        >
                          {t("Publish.label")}
                        </button>
                      </div>
                    )}
                    {/* <div className="col-lg-8 p-0 text-end">
                      <span onClick={() => gotoTopic(list?.name, list?.id)}><strong>3</strong> <BiGitMerge /></span>
                    </div> */}
                  </div>
                </div>
              )}
              <Collapse in={shown[list?.id]}>
                <div className="col-lg-8 p-1">
                  {type === "STANDARD" && (
                    <div>{categorydata?.map((item, index) => {
                      return (
                        <div className="card Standards_Overview_Card 2 mb-2">
                          <div className="card-body p-0">
                            <div className="SOC_Add_Card_row01">
                              <div className="SOC_Add_Card_row01_head">
                                {/* <div className="expand_RswBox">
                                  <BiChevronDown
                                    onClick={(e) => handleExpandDs(e, item.categoryType)}
                                    aria-controls="example-collapse-text"
                                    aria-expanded={shownInside[item.categoryType]}  ></BiChevronDown>
                                </div> */}
                                <div className="SOC_view_data d-flex ps-2">
                                  <h6 className="mb-0 me-2" >{item.categoryType}</h6>
                                  {/* <span><strong>
                                  {countCalculate(item.categoryType)}
                                  </strong> <BiGitMerge /></span> */}
                                </div>
                              </div>
                              <Collapse in={shownInside[item.categoryType]}>
                                <div>
                                  {data.length > 0 && <Topics
                                    data={data}
                                    sId={list.id}
                                    handleDeleteCallback={handleDeleteCallback}
                                    handleEditTopicCallback={handleEditTopicCallback}
                                    handleTopicChild={handleTopicChild}
                                    categoryType={item.categoryType}
                                    handleCount={handleCount}
                                    listData={list}
                                  />}
                                  <div className="col-lg-12 p-1 ps-5" id="idTopic">
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() => {
                                        setShowTopic(true);
                                        setEditTopicId("");
                                        setStdId(list?.id);
                                        setShown({
                                          ...shown,
                                          [list?.id]: true,
                                        });
                                      }}
                                    >
                                      <BiPlus className="me-2"> </BiPlus>
                                      {t("Topic.label")}
                                    </button>
                                  </div>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        </div>)
                    })}</div>
                  )}
                  {data.length > 0 && type === "TOPIC" && (
                    <Metric
                      data={data}
                      sId={stdId}
                      topicId={list.id}
                      handleDeleteCallback={handleDeleteMetricCallback}
                      handleEditMetricCallback={handleEditMetricCallback}
                      handleMetricChild={handleMetricChild}
                    />
                  )}

                  {type === "METRIC" && (
                    <DataPoints
                      data={data}
                      sId={stdId}
                      metricId={list.id}
                      topicId={topicId}
                      handleDeleteCallback={handleDeleteDataPointCallback}
                      handleEditDataPointCallback={handleEditDataPointCallback}
                      handleMetricChild={handleMetricChild}
                      equation={equation}
                    />
                  )}

                  {(() => {
                    // console.log('dsfsdfsd',type)
                    switch (type) {
                      // case "STANDARD":
                      //   return (
                      //     <div className="col-lg-12 p-1" id="idTopic">
                      //       <button
                      //         className="btn btn-secondary"
                      //         onClick={() => {
                      //           setShowTopic(true);
                      //           setEditTopicId("");
                      //           setStdId(list?.id);
                      //           setShown({
                      //             ...shown,
                      //             [list?.id]: true,
                      //           });
                      //         }}
                      //       >
                      //         <BiPlus className="me-2"> </BiPlus>
                      //         {t("Topic.label")}
                      //       </button>
                      //     </div>
                      //   );
                      case "TOPIC":
                        return (
                          <div className="col-lg-12 p-1" id="idMetric">
                            <button
                              className="btn btn-secondary"
                              onClick={() => {
                                setShowMetric(true);
                                setEditTopicId("");
                                setTopicId(list?.id);
                                setEditMetricId("");
                                setShown({
                                  ...shown,
                                  [list.id]: true,
                                });
                              }}
                            >
                              <BiPlus className="me-2"> </BiPlus>
                              {t("Metric.label")}
                            </button>
                          </div>
                        );
                      case "METRIC":
                        return (
                          <div className="col-lg-12 p-1" id="idParametrs">
                            <button
                              className="btn btn-secondary"
                              onClick={() => {
                                setShowDataPoints(true);
                                setEditTopicId("");
                                setMetricId(list?.id);
                                setShown({
                                  ...shown,
                                  [list.id]: true,
                                });
                              }}
                            >
                              <BiPlus className="me-2"> </BiPlus>
                              {t("DataPoint.label")}
                            </button>
                          </div>
                        );
                      default:
                        return " ";
                    }
                  })()}
                </div>
              </Collapse>
            </div>
            {showTopic && (
              <AddTopic
                stdId={stdId}
                handleDiscard={handleDiscard}
                editTopicId={editTopicId}
                handleSave={handleAfterSave}
                currentcategory={currentcategory}
              />
            )}
            {openStandardSave && (
              <StandardsCreate
                handleCreateCallback={handleEditCallback}
                editStandard={editStandardItem}
              />
            )}
            {showMetric && (
              <CreateMetric
                stdId={stdId}
                handleDiscard={handleMetricDiscard}
                topicId={topicId}
                editMetricId={editMetricId}
                handleSave={handleAfterMetricSave}
              />
            )}
            {showDataPoints && (
              <div>
                <CreateDataPoint
                  handleDiscard={handleMetricDiscard}
                  metricId={metricId}
                  editDataPointId={editDataPointId}
                  handleSave={handleAfterDataPointSave}
                  editData={editdata}
                /></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
StandardsAdminMain.propTypes = {};
export default withTranslation()(StandardsAdminMain);
